/* selectable-list.css */

:host {
    display: block;
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  li {
    padding: 8px 16px;
    cursor: pointer;
    transition: background-color 0.3s ease;
  }
  
  li:hover {
    background-color: #f0f0f0;
    color: var(--text-color)
  }
  
  .selected {
    background-color: var(--primary-color);
    color: white
  }
  
  label {
    cursor: pointer
  }  
  input {
    cursor: pointer
  }
  .error{
    color: var(--error-color-main)
  }